export default __webpack_public_path__ + "static/how-to-make-good-content-for-socialmedia-cb374b0b2679f52a6b68559c7d096c05.jpg";